export default __webpack_public_path__ + "static/media/ESPOL-GTSI-MR.935c1f53.svg";